<template>
	<div
		class="list--container list--view"
		:class="listContainerClass"
	>
		<slot name="list-header" />
		<div
			ref="listBody"
			class="list-body"
			:class="listBodyClass"
		>
			<slot
				v-if="paginatedItems.length === 0 && enableEmptyMsg"
				name="no-results"
			>
				<div
					class="flex flex-1 no-data"
					:class="{ 'p-2': isMobileWebApp, 'p-5': !isMobileWebApp }"
				>
					{{ emptyMsg }}
				</div>
			</slot>

			<!-- swipable row -->
			<InfiniteScroll
				v-else-if="swipable"
				:class="scrollContainerClass"
				:is-last-page="isLastPage"
				@load-more="loadMore"
			>
				<slot name="before-items" />
				<SwipeRow
					v-for="(item, index) in paginatedItems"
					:key="`${$vnode.key}-swipe-row-${index}`"
					:item="item"
					:left-enabled="hasSwipeLeftOptions"
					:right-enabled="hasSwipeRightOptions"
					@swipe:left="handleSwipeLeft"
					@swipe:right="handleSwipeRight"
				>
					<template>
						<slot
							:item="item"
							name="item-row"
						/>
					</template>
					<template
						slot="left"
					>
						<!-- left swipe side template and slot-scope="{ item }" is the item clearly -->
						<div
							class="swipeout-action action-panel-left"
							:class="{ visible: hasSwipeLeftOptions }"
						>
							<RowSwipeAction :icon="swipeLeftOptions ? swipeLeftOptions.icon : ''" />
						</div>
					</template>
					<template
						slot="right"
					>
						<!-- right swipe side template and slot-scope="{ item }" is the item clearly -->
						<div
							class="swipeout-action action-panel-right"
							:class="{ visible: hasSwipeRightOptions }"
						>
							<RowSwipeAction
								:icon="swipeRightOptions ? swipeRightOptions.icon : ''"
							/>
						</div>
					</template>
				</SwipeRow>
			</infinitescroll>
			<!-- normal row -->
			<InfiniteScroll
				v-else
				:class="scrollContainerClass"
				:is-last-page="isLastPage"
				@load-more="loadMore"
			>
				<slot name="before-items" />
				<slot
					v-for="item in paginatedItems"
					:item="item"
					name="item-row"
				/>
			</infinitescroll>
		</div>
	</div>
</template>

<script>
import SwipeRow from '../../plugins/vue-swipe-actions/components/SwipeRow';
import RowSwipeAction from './RowSwipeAction';
import $I18n from '../../i18n';
import InfiniteScroll from '@components/infinite-scroll/InfiniteScroll';
import { mapGetters } from 'vuex';
export default {
	name:       'ListView',
	components: {
		InfiniteScroll,
		RowSwipeAction,
		SwipeRow,
	},
	props: {
		items: {
			type:    Array,
			default: () => [],
		},
		emptyMsg: {
			type:    String,
			default: $I18n.trans('commons.no_results'),
		},
		labels: {
			type:    Object,
			default: () => ({
				cancelBtn: $I18n.trans('commons.cancel'),
			}),
		},
		dropdownDisabled: {
			type:    Boolean,
			default: false,
		},
		listContainerClass: {
			default: () => [],
		},
		listBodyClass: {
			default: () => [],
		},
		scrollContainerClass: {
			type:    [String, Array, Object],
			default: '',
		},
		swipable: {
			type:    Boolean,
			default: true,
		},
		swipeLeftOptions: {
			type:    Object,
			default: null,
		},
		swipeRightOptions: {
			type:    Object,
			default: null,
		},
		filtersLabel: {
			type:    String,
			default: '',
		},
		recyclerPageSize: {
			type:    Number,
			default: 20,
		},
		enableRecyclerView: {
			type:    Boolean,
			default: false,
		},
		enableEmptyMsg: {
			type:    Boolean,
			default: true,
		},
	},
	data() {
		return {
			itemsLimit: 0,
			isLastPage: false,
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
		paginatedItems() {
			return this.items.slice(0, this.itemsLimit);
		},
		hasSwipeLeftOptions() {
			return this.swipeLeftOptions && !!Object.keys(this.swipeLeftOptions).length;
		},
		hasSwipeRightOptions() {
			return this.swipeRightOptions && !!Object.keys(this.swipeRightOptions).length;
		},
	},
	created() {
		this.itemsLimit = this.recyclerPageSize;
	},
	methods: {
		loadMore() {
			if (this.itemsLimit >= this.items.length) this.isLastPage = true;
			else this.itemsLimit += this.recyclerPageSize;
		},
		handlePlay(item) {
			this.$emit('play', item);
		},
		handleClearFilters() {
			this.activeFilters = [];
		},
		handleRemoveFilter(id) {
			this.activeFilters = this.activeFilters.filter((e) => e.id !== id);
		},
		handleSwipeLeft({ item, _index, _side, swipeRow }) {
			this.swipeLeftOptions.action(item);
			swipeRow.close();
		},
		handleSwipeRight({ item, _index, _side, swipeRow }) {
			this.swipeRightOptions.action(item);
			swipeRow.close();
		},
	},
};
</script>

<style lang="scss" scoped>
.list--container.list--view {
	position: relative;
}

// .list-body {}

.no-data {
	white-space: normal;
	text-align: center;
}
</style>
